package com.nonopn.skydome.common.app.pages.main.model.api

import com.nonopn.skydome.common.app.pages.probes.ProbeStatusInput
import com.nonopn.skywatcher.maps.Circle
import com.nonopn.skywatcher.maps.LatLng
import kotlinx.serialization.Serializable

@Serializable
data class Probe(
    val uuid: String = "",
    val name: String,
    val latitude: Double,
    val longitude: Double,
    val radiusKm: Int,
    val enabled: Boolean,
    val isMain: Boolean,
    val isSkysentinel: Boolean = false,
    val isVirtual: Boolean,
    val createdAtSecondsUtc: Long = 0L,
    // Billing status (see ThunderDetection): trial | unpaid | active | expired
    val status: String? = null,
    val isDemo: Boolean = false,
    val validUntilSecondsUtc: Long? = null,
    val trialEndsAtSecondsUtc: Long? = null,
) {
    fun statusInput() = ProbeStatusInput(
        status = status,
        isDemo = isDemo,
        enabled = enabled,
        validUntilSecondsUtc = validUntilSecondsUtc,
        trialEndsAtSecondsUtc = trialEndsAtSecondsUtc,
    )

    fun id() = "circle_${name}_$radiusKm"

    fun latLng() = LatLng(latitude, longitude)

    fun coordinates(): LatLng = LatLng(latitude = latitude, longitude = longitude)

    fun toCircle() = Circle(
        position = coordinates(),
        radiusKm = radiusKm
    )
}
